import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail, Phone, MapPin } from "lucide-react";
import { siteInfo, navLinks } from "../mock";

export default function Footer() {
  return (
    <footer className="bg-[var(--ka-teal-darker)] text-white">
      <div className="container-ka py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="font-serif text-2xl mb-3">
            {siteInfo.brand}
            <sup className="text-[10px] ml-0.5">{siteInfo.trademark}</sup>
          </div>
          <p className="text-sm text-white/70 leading-relaxed">
            High-quality, healthy, home-made Keto foods delivered across
            Chennai. Eat Keto. Get Fit.
          </p>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.18em] mb-4 text-white/80">
            Explore
          </h4>
          <ul className="space-y-2 text-sm">
            {navLinks.map((l) => (
              <li key={l.path}>
                <Link
                  to={l.path}
                  className="text-white/80 hover:text-white transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.18em] mb-4 text-white/80">
            Contact
          </h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex gap-2">
              <MapPin size={16} className="mt-0.5 shrink-0" />
              <span>{siteInfo.address}</span>
            </li>
            <li className="flex gap-2 items-center">
              <Phone size={16} className="shrink-0" />
              <a href={`tel:${siteInfo.phoneRaw}`} className="hover:text-white">
                {siteInfo.phone}
              </a>
            </li>
            <li className="flex gap-2 items-center">
              <Mail size={16} className="shrink-0" />
              <a
                href={`mailto:${siteInfo.email}`}
                className="hover:text-white break-all"
              >
                {siteInfo.email}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.18em] mb-4 text-white/80">
            Follow
          </h4>
          <div className="flex gap-3">
            <a
              href={siteInfo.facebook}
              target="_blank"
              rel="noreferrer"
              className="w-10 h-10 rounded-full border border-white/30 inline-flex items-center justify-center hover:bg-white hover:text-[var(--ka-teal-darker)] transition-colors"
              aria-label="Facebook"
            >
              <Facebook size={16} />
            </a>
            <a
              href="#"
              className="w-10 h-10 rounded-full border border-white/30 inline-flex items-center justify-center hover:bg-white hover:text-[var(--ka-teal-darker)] transition-colors"
              aria-label="Instagram"
            >
              <Instagram size={16} />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-ka py-5 text-xs text-white/60 flex flex-col md:flex-row items-center justify-between gap-2">
          <span>
            © {new Date().getFullYear()} {siteInfo.brand}. All rights reserved.
          </span>
          <span>Made with care in Chennai.</span>
        </div>
      </div>
    </footer>
  );
}
